import BaseEvaluator from './BaseEvaluator';

export default class NotEmptyEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'not_empty';
  }

  validate() {
    this.isValid = this.value !== null && this.value !== undefined && this.value !== '';
    if (Array.isArray(this.value)) {
      this.isValid = this.isValid && this.value.length > 0;
    }
    return this.isValid;
  }
}
